<template>
  <CRow>
    <CCol xs="12" sm="4" class="second-child" @click="open = !open">
      <ToolTipWrapper :child="child" :open="open" />
    </CCol>
    <CCol class="small-child-wrapper" xs="12" sm="8">
      <CRow
        v-if="child.children"
        class="child-row"
        :class="{ 'is-hidden': !open }"
      >
        <UnderChild
          :children="child.children"
          :main-index="mainIndex"
          :child-index="childIndex"
        />
      </CRow>
    </CCol>
  </CRow>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { Children } from "@/types/jsonTypes";
import UnderChild from "@/components/UnderChild.vue";
import ToolTipWrapper from "@/components/ToolTipWrapper.vue";
import { emitter } from "@/events";

export default defineComponent({
  name: "Children",
  components: {
    ToolTipWrapper,
    UnderChild,
  },
  props: {
    mainIndex: {
      type: Number,
      required: true,
    },
    child: {
      type: Object as PropType<Children>,
      required: true,
    },
    childIndex: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      open: false,
    };
  },
  mounted() {
    emitter.on("global-handle", (evt: Record<string, boolean> | any) => {
      if (evt) {
        this.open = evt.open;
      }
    });
  },
  beforeUnmount() {
    emitter.off("global-handle");
  },
});
</script>

<style scoped lang="scss">
.second-child {
  min-height: 175px;
  max-height: 175px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0.5rem 0;
  padding: 0.5rem 0.5rem;

  ::v-deep(.child-wrapper) {
    background: #2d594a;
    color: #fff;
  }
}
.small-child-wrapper {
  margin: 0.5rem 0;
  .child-row {
    opacity: 1;
    transition: opacity 200ms ease-in-out, height 100ms linear 200ms;

    &.is-hidden {
      height: 0;
      opacity: 0;
      pointer-events: none;
    }
  }
}
</style>
